<template>
    <div>
        <swb-query-sort-area ref="query_model_ctrl" name="query-sort-area" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :queryHandler="queryHandler"></swb-query-sort-area>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="domHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {$, Utils} from '../../app.base'
    import {DomSizeWatcher, MsgBox, Vue} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'
    import {checkUserActionPerm} from '../index'

    import finacApi from '../../api/finac'

    import SwbInvoiceVoucherInfo from './InvoiceVoucherInfo';
    //
    import SwbQuerySortArea from '../query/QuerySortArea';
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbInvoiceVoucherInfo);

    Vue.regist(SwbQuerySortArea);

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-invoice-voucher-list',
        path: '/invoice/voucher/list',
        avlActions: 'view_detail|recv_make_out|invalidate|delete',
        avlActionNames: '查看详情、作废、删除',
        avlScopes: 'retailer',
        desc: '发票单据列表',
        data: function () {
            return {
                confKey: 'swb-invoice-voucher-list',
                domHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 220,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                invoiceTypeMaps: getEnumMap('invoiceType', 'value2text')
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.domHeight = height;
            });
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-area"], .pagination-layout'));
            domSizeWatcher.start(500);
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'invoiceType': function (row, colName, colValue, rowIndex, btnName) {
                        return '<span>' + self.invoiceTypeMaps[row.invoiceType] + '</span>'
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if (self.checkActionPerm('view_detail')) {
                            btnList.push({
                                name: 'view_detail',
                                text: '查看明细'
                            });
                        }
                        // 已开具 可接收
                        if (self.checkActionPerm('recv_make_out') && row.collaboState == 1) {
                            btnList.push({
                                name: 'recv_make_out',
                                text: '接收'
                            });
                        }
                        // 已接收
                        if (self.checkActionPerm('confirmed') && row.collaboState == 2) {
                            btnList.push({
                                name: 'confirmed',
                                text: '确认'
                            });
                        }
                        // 已接收  可退回
                        if (self.checkActionPerm('reject_make_out') && row.collaboState == 2 && row.relVoucherId == -1) {
                            btnList.push({
                                name: 'reject_make_out',
                                text: '退回'
                            });
                        }
                        // 开票方不协同的可作废
                        if (self.checkActionPerm('invalidate') && row.collaboState == 4 && !row.issuerOlCollabo && row.relVoucherId == -1) {//   仅临采可作废
                            btnList.push({
                                name: 'invalidate',
                                text: '作废'
                            });
                        }
                        if (self.checkActionPerm('delete') && row.collaboState == 6) {
                            btnList.push({
                                name: 'delete',
                                text: '删除'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if (btnName == 'view_detail') {
                            self.showInvoiceVoucher(row.id);
                        } else if (btnName == 'recv_make_out') {
                            self.receiptInv(row.id);
                        } else if (btnName == 'confirmed') {
                            self.confirmed(row.id)
                        } else if (btnName == 'invalidate') {
                            self.getDiscard(row.id);
                        } else if (btnName == 'delete') {
                            self.invoiceVoucherDelete(row.id);
                        } else if (btnName == 'reject_make_out') {
                            self.rejectInvoiceVoucher(row.id);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log('----- 双击数据行 ----');
                    console.log(row);
                }
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                //
                this.pageNumber = 1;
                this.getInvoiceVoucherList();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getInvoiceVoucherList();
            },
            //获取发票单据列表
            getInvoiceVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber
                };

                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if (Utils.isNoB(filterItems.collaboState)) {
                    // 协同状态：TO_BE_ISSUED("待开具", 0), ISSUED("已开具", 1), RECEIVED("已接收", 2), CONFIRMED("已确认", 3), RETURNING("退回中", 4), RETURNED("已退回", 5),
                    let collaboStates = [
                        getEnumInfoWith('invoiceCollaboState', 'name', 'Init').value,
                        getEnumInfoWith('invoiceCollaboState', 'name', 'TO_BE_ISSUED').value,
                        getEnumInfoWith('invoiceCollaboState', 'name', 'ISSUED').value,
                        getEnumInfoWith('invoiceCollaboState', 'name', 'RECEIVED').value,
                        getEnumInfoWith('invoiceCollaboState', 'name', 'CONFIRMED').value,
                        getEnumInfoWith('invoiceCollaboState', 'name', 'RETURNING').value,
                        getEnumInfoWith('invoiceCollaboState', 'name', 'RETURNED').value
                    ];
                    filterItems.collaboStates = collaboStates;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.getInvoiceVoucherList(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let invoiceList = result.data.rows;
                        for (let i = 0; i < invoiceList.length; i++) {
                            let invoice = invoiceList[i];
                            invoice.totalAmount = (invoice.totalAmount || 0).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
                            invoice.amount = (invoice.amount || 0).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
                        }
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        self.renderTable(invoiceList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 发票详情
            showInvoiceVoucher: function (id) {
                let theDlg = Vue.$showDialog({
                    title: '发票单据 - 详情',
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: '关闭',
                    width: 1000,
                    height: -60,
                    template: '<swb-invoice-voucher-info :id="id"></swb-invoice-voucher-info>',
                    data: {
                        id: id
                    },
                    methods: {},
                    okClicked: function () {
                        theDlg.close();
                    }
                });
            },
            //收到发票
            receiptInv: function (id) {
                let self = this;
                self.$confirm('确认收到发票？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    finacApi.receiveInvoiceVoucher(postData, function (result) {
                        msgBoxDlg.close();
                        if (result.type == 'info') {
                            MsgBox.success('收票成功');
                            self.getInvoiceVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 确认
            confirmed: function (id) {
                let self = this;
                self.$confirm('确认后发票不可退回，请确认发票内容信息是否正确？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    finacApi.confirmedInvoiceVoucher(postData, function (result) {
                        msgBoxDlg.close();
                        if (result.type == 'info') {
                            MsgBox.success('收票成功');
                            self.getInvoiceVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 退回
            rejectInvoiceVoucher: function (id) {
                let self = this;
                self.$confirm('确定要退回吗？', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    finacApi.rejectInvoiceVoucher({id: id}, function (result) {
                        msgBoxDlg.close();
                        if (result.type == 'info') {
                            MsgBox.success('退回成功');
                            self.getInvoiceVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            //作废
            getDiscard: function (id) {
                let self = this;
                self.$confirm('确定要作废当前发票记录吗？', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: id
                    };
                    let msgBoxDlg = MsgBox.loading();
                    finacApi.invalidateInvoiceVoucher(postData, function (result) {
                        msgBoxDlg.close();
                        if (result.type == 'info') {
                            MsgBox.success('作废成功');
                            self.getInvoiceVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            //删除
            invoiceVoucherDelete: function (id) {
                let self = this;
                self.$confirm('确认要删除当前发票记录？', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    finacApi.deleteInvoiceVoucher(postData, function (result) {
                        msgBoxDlg.close();
                        if (result.type == 'info') {
                            MsgBox.success('删除成功');
                            self.getInvoiceVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/invoiceVoucher/InvoiceVoucherList.vue